import { useState } from "react";
import { FloppyDisk, X } from "@phosphor-icons/react";

const Field = ({ label, required, testid, ...props }) => (
  <div className="flex flex-col gap-1.5">
    <label className="text-xs font-bold uppercase tracking-wide text-slate-600">
      {label} {required && <span className="text-red-600">*</span>}
    </label>
    <input
      type="text"
      className="w-full bg-white border border-slate-300 rounded px-3 py-2 text-sm focus:ring-2 focus:ring-[#0A3F9A]"
      data-testid={testid}
      {...props}
    />
  </div>
);

export default function SaveToHistoryDialog({ proposal, saving, onCancel, onSubmit }) {
  const [form, setForm] = useState({ nama_pasien: "", ruang_kelas: "", umur: "", no_mr: "" });
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });
  const valid = form.nama_pasien.trim() && form.ruang_kelas.trim();
  return (
    <div
      className="fixed inset-0 z-50 bg-slate-900/50 flex items-center justify-center p-4"
      data-testid="save-history-dialog"
    >
      <div className="bg-white rounded shadow-xl w-full max-w-lg">
        <div className="px-5 py-4 border-b border-slate-200 flex items-start justify-between">
          <div>
            <div className="text-[11px] uppercase tracking-[0.2em] font-bold text-slate-500">Simpan ke Riwayat</div>
            <div className="font-semibold text-slate-900">Lengkapi data pasien</div>
            <div className="text-xs text-slate-500 mt-0.5">{proposal.ringkasan}</div>
          </div>
          <button onClick={onCancel} className="text-slate-500 hover:text-slate-900 p-1" data-testid="save-history-close">
            <X size={18} />
          </button>
        </div>
        <div className="p-5 grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="md:col-span-2">
            <Field label="Nama Pasien" required value={form.nama_pasien} onChange={set("nama_pasien")} placeholder="Mis. MUHAMAD SANWANI" testid="save-history-nama" />
          </div>
          <Field label="Ruang" required value={form.ruang_kelas} onChange={set("ruang_kelas")} placeholder="Mawar 302" testid="save-history-ruang" />
          <Field label="Umur" value={form.umur} onChange={set("umur")} placeholder="53 Tahun" testid="save-history-umur" />
          <Field label="No MR / Registrasi" value={form.no_mr} onChange={set("no_mr")} placeholder="30-06-65" testid="save-history-nomr" />
          <div className="flex items-end text-xs text-slate-500">
            Kelas: <b className="ml-1">{proposal.kelas}</b>
          </div>
        </div>
        <div className="px-5 py-4 border-t border-slate-200 flex justify-end gap-2">
          <button onClick={onCancel} className="px-4 py-2 text-sm rounded border border-slate-300 hover:bg-slate-50" data-testid="save-history-cancel">
            Batal
          </button>
          <button
            onClick={() => onSubmit(form)}
            disabled={!valid || saving}
            className="bg-[#057A55] text-white px-4 py-2 rounded hover:bg-[#046148] text-sm font-medium inline-flex items-center gap-2 disabled:opacity-50"
            data-testid="save-history-submit"
          >
            <FloppyDisk size={16} weight="duotone" /> {saving ? "Menyimpan..." : "Hitung & Simpan"}
          </button>
        </div>
      </div>
    </div>
  );
}
